import { object } from 'yup'
import { Drawer } from 'components/Drawer'
import Styles from './CustomizeDrawer.module.scss'
import { Formik } from 'formik'
import { CustomizeDrawerProps } from './Types'
import { Button } from 'blaze-ui/Button'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { Field } from 'components/Wizards/Wizard/Form/Field'
import { ConditionalLanguageInputField as LanguageInputField } from '../../../../../Wizard/Form/LanguageInputField/ConditionalLanguageInputField'

export const CustomizeDrawer = observer((props: CustomizeDrawerProps) => {
  const { closeDrawer } = useRootStore().drawersStore
  const { schema, onSubmit, initialValues, ...rest } = props
  const fields = Object.entries(schema.fields).filter((field) => {
    const { meta } = field[1].describe()
    return meta.overflow
  })
  const overflowSchema = object().shape(Object.fromEntries(fields))

  const handleSubmit = async (values: any) => {
    onSubmit(values)
    closeDrawer()
  }

  return (
    <Drawer.Root {...rest}>
      <Drawer.Portal>
        <Drawer.Overlay withBlur />
        <Drawer.Content>
          <div style={{ height: '100%' }} data-vaul-no-drag>
            <Drawer.InnerContent color="var(--light-100)">
              <Drawer.Top>
                <div />
                <Drawer.Title asChild>
                  <span className={Styles.title}>More ways to configure</span>
                </Drawer.Title>
                <Drawer.Close label="Cancel" variant="ghost" position="right" />
                <Drawer.Description />
              </Drawer.Top>
              <Drawer.Container padding="5px 15px 15px 15px">
                <Formik
                  validationSchema={overflowSchema}
                  onSubmit={handleSubmit}
                  initialValues={schema.cast({ ...schema.getDefault(), ...initialValues }, { assert: false })}
                >
                  {({ submitForm }) => (
                    <div className={Styles.drawerContainer}>
                      <LanguageInputField label="Language" />
                      {fields.map(([name, schema], i) => (
                        <Field key={name} name={name} schema={schema} autoFocus={i === 0} />
                      ))}
                      <Button aria-label="Confirm" size="lg" variant="primary" onPress={() => submitForm()} fullWidth>
                        Confirm
                      </Button>
                    </div>
                  )}
                </Formik>
              </Drawer.Container>
            </Drawer.InnerContent>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
